import { Checkbox, Stack } from '@mui/material'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'
import avatar from '../../../../../../assets/images/common/avatar.svg'
import { getStyles } from '../../../../../../utils/utils/commonUtils'
import requestsManagementStyles from '../../../../styles/requestsManagementStyles'

function DealerCard({ dealer, selected, onSelect, onlyShow, requestsCount }) {
  const classes = getStyles(requestsManagementStyles)

  
  return dealer ? (
    <Box
      sx={{
        ...classes.dealerCard,
        border: onlyShow ? 'none' : classes.dealerCard.border,
      }}
      className={'jst-sb aln-center'}
      onClick={onSelect}
    >
      <Box className={'aln-center'}>
        <img alt={''} src={avatar} style={{ width: '35px', height: '35px' }} />

        <Box ml={1.5}>
          <Box mt={0.5}>
            <Typography variant={'subtitle1'}>{dealer.displayName}</Typography>
          </Box>
        </Box>
      </Box>
      <Stack
        spacing={'4px'}
        direction={'row'}
        alignItems={'center'}
        color={'rgb(112, 145, 183)'}
        fontWeight={700}
      >
        {requestsCount && `(${requestsCount})`}
        {!onlyShow && <Checkbox checked={selected} onChange={onSelect} />}
      </Stack>
    </Box>
  ) : (
    <Typography variant={'subtitle1'}>{'Дилер не назначен'}</Typography>
  )
}

export default observer(DealerCard)
